import React from 'react';
import { Outlet } from 'react-router-dom';
import MarketingSidebar from './MarketingSidebar';
import MarketingHeader from './MarketingHeader';
import { useAuth } from '../../contexts/AuthContext';

const MarketingLayout = () => {
  const { user } = useAuth();

  if (!user) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen bg-gray-50">
      <MarketingSidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <MarketingHeader />
        <main className="flex-1 overflow-y-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MarketingLayout;
